import * as Types from '../../../../../../../types.generated';

import { gql } from '@apollo/client';
import { AvatarProfileImageFragmentDoc } from '../../../../../../../fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CommentMentionPeopleQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CommentMentionPeopleQuery = { __typename?: 'Query', AdminEmployees: { __typename?: 'Employees', objects: Array<{ __typename?: 'Employee', id: number, name: string, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null }> } };

export type AtMentionEmployeeFragment = { __typename?: 'Employee', id: number, name: string, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null };

export const AtMentionEmployeeFragmentDoc = gql`
    fragment AtMentionEmployee on Employee {
  id
  name
  profileImage {
    ...AvatarProfileImage
  }
}
    ${AvatarProfileImageFragmentDoc}`;
export const CommentMentionPeopleDocument = gql`
    query CommentMentionPeople {
  AdminEmployees(userTypes: [ADMIN, MANAGER]) {
    objects {
      ...AtMentionEmployee
    }
  }
}
    ${AtMentionEmployeeFragmentDoc}`;

/**
 * __useCommentMentionPeopleQuery__
 *
 * To run a query within a React component, call `useCommentMentionPeopleQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentMentionPeopleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentMentionPeopleQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommentMentionPeopleQuery(baseOptions?: Apollo.QueryHookOptions<CommentMentionPeopleQuery, CommentMentionPeopleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommentMentionPeopleQuery, CommentMentionPeopleQueryVariables>(CommentMentionPeopleDocument, options);
      }
export function useCommentMentionPeopleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommentMentionPeopleQuery, CommentMentionPeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommentMentionPeopleQuery, CommentMentionPeopleQueryVariables>(CommentMentionPeopleDocument, options);
        }
export type CommentMentionPeopleQueryHookResult = ReturnType<typeof useCommentMentionPeopleQuery>;
export type CommentMentionPeopleLazyQueryHookResult = ReturnType<typeof useCommentMentionPeopleLazyQuery>;
export type CommentMentionPeopleQueryResult = Apollo.QueryResult<CommentMentionPeopleQuery, CommentMentionPeopleQueryVariables>;